export default __webpack_public_path__ + "static/media/113_Gmagicard_Kawai_0001.0733adb4.png";